import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getManagementOffice from "@/types/responses/getManagementOffice";
import getOperationOffice from '@/types/responses/getOperationOffice';
import getAccountResponse from '@/types/responses/getAccount';
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';
import i18n from '@/lang/i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountNamesAutoComplete',
  props: {
    modelValue: {},
    managementOffice: {},
    operationOffices: {},
    errorMessages: {},
    readonly: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const label = i18n.global.t('pages.accounts.accountName');
const items = ref<getAccountResponse[]>([]);

onMounted(() => {
  Api().autoCompleteAccounts(undefined).then((data) => {
    items.value = data;
  });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: _unref(label),
    itemName: "name",
    items: items.value,
    "management-office": __props.managementOffice,
    "operation-offices": __props.operationOffices,
    "error-messages": __props.errorMessages,
    readonly: props.readonly,
    isCombobox: true,
    mapToObject: (v) => ({ name:v })
  }, null, 8, ["modelValue", "label", "items", "management-office", "operation-offices", "error-messages", "readonly", "mapToObject"]))
}
}

})